/**
 * @file Donation CTAs
 */

import { gsap } from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';

/**
 * Donation CTAs Component
 */
const vDonationCtas = () => {
	const donationCtas = document.querySelector( '.v-donation-ctas' );

	if ( ! donationCtas ) {
		return;
	}

	const stayUpdated = donationCtas.querySelector( '.v-donation-ctas__cta--right' );

	if ( ! stayUpdated ) {
		return;
	}

	gsap.registerPlugin( ScrollToPlugin );

	stayUpdated.addEventListener( 'click', ( e ) => {
		e.preventDefault();

		if ( ! stayUpdated.contains( e.target ) ) {
			return;
		}

		const newsletter = document.querySelector( stayUpdated.hash );

		gsap.to( window, {
			duration: .5,
			ease:     'power1.inOut',
			scrollTo: newsletter,
		} );
	} );
};

export default vDonationCtas;
